import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { LoginMenu } from './api-authorization/LoginMenu';
import './NavMenu.css';
import AuthFunctions from './services/AuthService';
import Session from './auth/Session';

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);
        var currentUrl = window.location.href;
        const url = new URL(currentUrl);

        var anonymousView = this.props.anonymousView;
        //const search = this.props.location.search;
        const params = new URLSearchParams(url.search);
        
        const id = params.get('id');
        const getAll = params.keys();
        for (const key of params.keys()) {
            console.log(key);
        }


        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true,
            isAuthenticated: false,
            userName: null,
            userClient: { logoLocation: '' },
            lease: {},
            leaseId: id,
            anonymousView: anonymousView
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    componentDidMount() {
        //this._subscription = authService.subscribe(() => this.populateState());
        this.populateState();
    }

    componentWillUnmount() {
        //authService.unsubscribe(this._subscription);
    }

    async populateState() {
        //const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
        const isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        var currentUrl = window.location.href;
        //var currentUrl = window.location.href;
        if (currentUrl.includes("/admin/client") || this.state.anonymousView === true) {
            this.setState({ hideLogo: true });
        }
        if (isAuthenticated) {
            const userClient = this.getUserClient();
            const userName = Session.getUserName();
            this.setState({
                isAuthenticated,
                userName: userName
            });
        }
    }

    render() {
        var currentUrl = window.location.href;
        var logoLocation = this.state.userClient.logoLocation;
        if (currentUrl.includes("/Comps/")) {
            logoLocation = "";
        } else {
            
        }
        return (
            <header>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white g-white-bg" light>
                    <Row className="sidebarRow" >
                        <Col lg="3" xs="3" style={{ 'maxWidth': '270px' }}>
                            <div>
                                {this.state.isAuthenticated === true && logoLocation && this.state.hideLogo != true && (
                                    <>
                                        <NavbarBrand tag={Link} to="/home" className="logoSpacing"><img src={logoLocation} className="headerImage" alt="logo"></img></NavbarBrand>
                                    </>
                                )}
                                {this.state.isAuthenticated === true && (!logoLocation || this.state.hideLogo == true ) && (
                                    <>
                                        <NavbarBrand tag={Link} to="/home" className="logoSpacing"></NavbarBrand>
                                    </>
                                )}
                                {this.state.isAuthenticated === false  && (
                                    <>
                                        <NavbarBrand tag={Link} to="/home" className="logoSpacing"><img src="Panoramic.png" className="headerImage" alt="logo"></img></NavbarBrand>
                                    </>
                                )}
                            </div>

                        </Col>
                        <Col className="g-logo-bg g-light-gray-c noPadRight" xs="9">
                            <div>
                                <Container className="noPadRight">

                                    <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                                    <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
                                        <ul className="navbar-nav flex-grow">
                                            {this.state.isAuthenticated === true && (
                                                <>
                                                    <NavbarBrand tag={Link} to="/home" style={{ 'marginRight': '0px' }}><img src="Panoramic.png" className="headerImage" alt="logo"></img></NavbarBrand>
                                                </>
                                            )}
                                            {this.state.isAuthenticated === false && (
                                                <>
                                                    <NavbarBrand tag={Link} to="/home" style={{ 'marginRight': '0px' }}></NavbarBrand>
                                                </>
                                            )}
                                            <LoginMenu>
                                            </LoginMenu>
                                        </ul>
                                    </Collapse>

                                </Container>
                            </div>

                        </Col>
                    </Row>

                </Navbar>
            </header>
        )
    }
    async getUserClient() {
        const token = Session.getToken();

        const response = await fetch(`api/Clients/GetUserClient`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        this.setState({ userClient: data });
    }
}
